import * as React from 'react';
import InputGroup from '../inputGroup/InputGroup';
import { SLoginIconField, SInput } from './style';
import CreditCardIcon from '../creditCardIcon/CreditCardIcon';
import { isFunction } from '../../helpers/common';
import { Rifm } from 'rifm';

export interface IInputValueProps {
  label: string;
  dataAt: string;
  name?: string;
  error?: string;
  onChange?: (event: any) => void;
  onFocus?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputType?: string;
  autoFocus?: boolean;
  value?: string;
  className?: string;
  maxLength?: number;
  icon?: string;
  placeholder?: string;
  isLogin?: boolean;
  backgroundColor?: string;
  pattern?: string;
  rifm?: any; // TODO
  tooltipContent?: string;
  creditCard?: boolean;
  disabled?: boolean;
  initErrorSpacing?: boolean;
  dataTestId?: string;
}

const renderInputWithNativeOnChange =
  (props: any) =>
  ({ value, onChange }) => {
    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (isFunction(props.onChange)) {
        props.onChange(event);
      }

      if (isFunction(onChange)) {
        onChange(event);
      }
    };
    return <SInput {...props} value={value} onChange={handleOnChange} />;
  };

const InputForm: React.FC<IInputValueProps> = ({
  value,
  name,
  inputType = 'text',
  onChange = () => {},
  onFocus = () => {},
  onBlur = () => {},
  autoFocus = false,
  label,
  placeholder = '',
  maxLength,
  className,
  dataAt,
  icon = '',
  isLogin = false,
  backgroundColor = 'transparent',
  rifm = null,
  pattern = '',
  tooltipContent = '',
  error = '',
  creditCard = false,
  disabled = false,
  initErrorSpacing = false,
  dataTestId,
}) => {
  const renderInput = renderInputWithNativeOnChange({
    name,
    onChange,
    type: inputType,
    placeholder,
    maxLength,
    onFocus,
    onBlur,
    'data-testid': dataTestId,
    'data-at': dataAt,
    isLogin,
    backgroundColor,
    pattern,
    autoFocus,
    error,
  });

  return (
    <InputGroup
      {...{
        initErrorSpacing,
        className,
        dataAt: `${dataAt}-group`,
        tooltipContent,
        disabled,
        label,
        error,
      }}
    >
      <div>
        {icon && <SLoginIconField icon={icon} />}
        {rifm ? (
          <Rifm {...rifm} onChange={onChange} value={value}>
            {renderInput}
          </Rifm>
        ) : (
          renderInput({ value, onChange })
        )}
        <CreditCardIcon input={true} value={value} detect={creditCard} />
      </div>
    </InputGroup>
  );
};

export default InputForm;
